// A mixin providing convenient access to the fcoUrl utility

import { fcoUrl } from '@/fcoModules/utilities';

// This can be used to easily build a URL relative to the root app context
export default {
    methods: { fcoUrl },
};
